export default "__VITE_ASSET__COEYq$10__"